import { __assign } from "tslib";
import React from "react";
import { useDCContext } from "../../common";
import { GroupProvider } from "./groupProvider";
import { isSourceWithOptions } from "../../interfaces";
import uuidv1 from "uuid/v1";

function renderGroupRenderer(sources, groupRenderer, singleRenderers) {
  var renderedSources = sources.sources.map(function (source) {
    if (source.source.data) {
      source.source.data.renderedContent = renderSingleRenderer(source, singleRenderers, true);
    }

    return source;
  });

  if (!groupRenderer) {
    return React.createElement(React.Fragment, null, renderedSources.map(function (s) {
      if (s.source.data) {
        return s.source.data.renderedContent;
      }

      return null;
    }));
  }

  var Component = groupRenderer;
  var srcs = renderedSources.map(function (s) {
    return s.source;
  });
  return React.createElement(GroupProvider, {
    sources: srcs
  }, React.createElement(Component, {
    sources: srcs
  }));
}

function renderSingleRenderer(source, renderers, isGroup) {
  var renderedContent = source.source.data && source.source.data.renderedContent;

  if (!renderedContent) {
    return null;
  }

  var singleRenderer = renderers && renderers.find(function (r) {
    return r.sourceType.includes(source.source.type);
  });

  if (!singleRenderer) {
    return renderedContent;
  }

  var Component = singleRenderer.component;
  var s = isGroup ? __assign(__assign({}, source.source), {
    data: __assign(__assign({}, source.source.data), {
      renderedContent: renderedContent
    })
  }) : source.source;
  return React.createElement(Component, {
    source: s,
    renderedContent: renderedContent,
    isGroup: Boolean(isGroup),
    key: uuidv1()
  });
}

function render(sources, renderers) {
  var singleRenderers = renderers && renderers.single;
  var groupRenderers = renderers && renderers.group;
  return sources.map(function (source) {
    if (isSourceWithOptions(source)) {
      return renderSingleRenderer(source, singleRenderers, false);
    }

    return renderGroupRenderer(source, groupRenderers, singleRenderers);
  });
}

var Content = function Content(_a) {
  var _b = _a.renderers,
      renderers = _b === void 0 ? {} : _b;
  var sources = useDCContext().sources;
  return React.createElement(React.Fragment, null, render(sources, renderers));
};

export { Content };